import { CardActionArea as MuiCardActionArea, CardMedia as MuiCardMedia, Grid, Stack as MuiStack } from "@mui/material";
import { Link as RouterLink } from "react-router-dom";

import type { ICraft } from "@framework/types";
import { Card, Typography } from "@dzambalaorg/ui-kit";

import { CraftButton } from "../../../../../../../components/buttons";
import { CraftIngredients } from "./menu";

interface ICraftItemProps {
  craft: ICraft;
}

export const CraftItem = (props: ICraftItemProps) => {
  const { craft } = props;

  return (
    <MuiCardActionArea component={RouterLink} to={`/recipes/craft/${craft.id}`}>
      <Card
        header={
          <Card.Header
            action={<CraftIngredients craft={craft} />}
            title={<MuiCardMedia image={craft.item?.components[0].template!.imageUrl} />}
            subheader={
              <MuiStack>
                <Typography variant="h5" color="textPrimary">
                  {craft.item?.components[0].template!.title}
                </Typography>
                <Typography variant="body2" color="textSecondary">
                  {craft.item?.components.map(comp => comp.template?.title).join(" + ")}
                </Typography>
              </MuiStack>
            }
          />
        }
      >
        <Card.Footer>
          <Grid container alignItems="center">
            <CraftButton craft={craft} />
          </Grid>
        </Card.Footer>
      </Card>
    </MuiCardActionArea>
  );
};
